// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3596R","rightAdornment":"Header_rightAdornment__1vXex"};